<div class="card" [class.completed]="$isCompleted()">

  <!-- Header -->
  <div class="header">
    <div class="header-text">
      <div class="title">Scan Bills</div>
      <div class="context">
        @if ($toolInput().jobName; as jobName) { Job: {{ jobName }} }
        @if ($toolInput().stageName; as stageName) { · Stage: {{ stageName }} }
        @if (!$isCompleted()) {
          · {{ $conversationFiles().length }} file{{ $conversationFiles().length !== 1 ? 's' : '' }} attached
        }
      </div>
    </div>
  </div>

  @if ($isCompleted()) {

    <!-- Completed state: collapsed, non-interactive -->
    @if ($status() === 'success') {
      <div class="status-row status-success">
        <i class="fa-solid fa-circle-check status-icon"></i>
        <div>
          <div class="status-label">{{ $selectedCount() }} bill{{ $selectedCount() !== 1 ? 's' : '' }} submitted for processing</div>
        </div>
      </div>
      @if ($selectedEnrichedFiles().length > 0) {
        <div class="completed-files">
          @for (item of $selectedEnrichedFiles(); track item.file.id) {
            <div class="completed-file-row">
              <div class="file-icon" [class.is-image]="item.isImage">
                @if (item.isImage) {
                  <img class="file-thumb" [src]="item.thumbnailUrl" alt="" loading="lazy" />
                } @else {
                  <i class="fa-solid {{ item.iconClass }}"></i>
                }
              </div>
              <span class="completed-file-name">{{ item.displayName }}</span>
            </div>
          }
        </div>
      }
    } @else {
      <div class="status-row status-declined">
        <i class="fa-solid fa-ban status-icon"></i>
        <div class="status-label">Bill scan declined</div>
      </div>
    }

  } @else {

    <!-- Active state: interactive file selection -->
    <div class="badge-row">
      <span class="badge-pending">Pending</span>
    </div>

    <div class="divider"></div>

    <!-- File rows -->
    @for (item of $enrichedFiles(); track item.file.id) {
      <div class="file-row" [class.selected]="$selectedIndexes().has(item.index)" (click)="toggleFile(item.index)">
        <wb-button-checkbox [checked]="$selectedIndexes().has(item.index)" />
        <div class="file-icon" [class.is-image]="item.isImage">
          @if (item.isImage) {
            <img class="file-thumb" [src]="item.thumbnailUrl" alt="" loading="lazy" />
          } @else {
            <i class="fa-solid {{ item.iconClass }}"></i>
          }
        </div>
        <div class="file-info">
          <div class="file-name">{{ item.displayName }}</div>
          <div class="file-type">{{ item.typeLabel }}</div>
        </div>
      </div>
    } @empty {
      <div class="empty-state">No files found in conversation</div>
    }

    <!-- Actions -->
    <div class="footer">
      @switch ($status()) {
        @case ('idle') {
          @let selectedCount = $selectedCount();
          <wb-button [label]="'Decline'" [displayStyle]="ButtonDisplayStyle.Tertiary" (onClick)="onDeclineClick()" />
          <wb-button [label]="'Process ' + selectedCount + ' bill' + (selectedCount !== 1 ? 's' : '')" [iconRight]="'fa-regular fa-arrow-turn-down-left'" [displayStyle]="ButtonDisplayStyle.Primary" [accent]="ButtonAccent.Accent" [disabled]="!$canScan()" (onClick)="onScanClick()" />
        }
        @case ('processing') {
          <wb-button [label]="'Processing bills...'" [displayStyle]="ButtonDisplayStyle.Primary" [accent]="ButtonAccent.Accent" [loading]="true" [disabled]="true" />
        }
        @case ('error') {
          <span class="error-text">{{ $errorMessage() || 'Scan failed' }}</span>
          <wb-button [label]="'Retry'" [displayStyle]="ButtonDisplayStyle.Primary" [accent]="ButtonAccent.Accent" (onClick)="onScanClick()" />
        }
      }
    </div>

  }

</div>
